// extracted by mini-css-extract-plugin
export default {"navigation":"styles_navigation__htEkc","navigation__link":"styles_navigation__link__Zl8ZK","navigation__active":"styles_navigation__active__zv2d-"};